import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'
import BadgeList from '@/design-system/atoms/BadgeList.vue'
import { FeatureType, useFilters } from '@/composables/useFilters'
import { useSelectionStore } from '@/pinia/selectionNew'
import { storeToRefs } from 'pinia'
import { CoreEntityDto } from '@/interfaces/core.interface'
import { getTitleKey } from '@/hooks/reports/useReport'
import { getRealmId } from '@/utils/realmId'
import { formatRange, useTimeSelection } from '@/composables/useTimeRange'

type BadgeListItem = {
  text: string
  color?: string
  children?: BadgeListItem[]
}
type Props = {
  showTimeSelection: boolean
  fullscreen: boolean
}

export default /*@__PURE__*/_defineComponent({
  __name: 'CollapseControllerSummaryNew',
  props: {
    showTimeSelection: { type: Boolean },
    fullscreen: { type: Boolean }
  },
  setup(__props: any) {

const props = __props
const { showTimeSelection } = toRefs(props)
const { t, locale } = useI18n()
const timeSelection = useTimeSelection()
const { range } = storeToRefs(timeSelection)
const filters = useFilters(FeatureType.AggregateAnalysis)
const businessTime = computed(() => {
  const businessDays = filters.current?.onlyBusinessDays ?? false
  const businessHours = filters.current?.onlyBusinessHours ?? false

  if (businessDays && businessHours)
    return (
      t('general__text__businesshours') + ', ' + t('general__text__mon-fri').toLocaleLowerCase()
    )
  if (businessDays) return t('general__text__mon-fri').toLocaleLowerCase()
  if (businessHours) return t('general__text__businesshours')

  return ''
})
const realm = getRealmId()

const { entityPath } = storeToRefs(useSelectionStore())

const badges = computed<BadgeListItem[]>(() => {
  const items: BadgeListItem[] = []

  if (showTimeSelection.value) {
    items.push(...makeTimeSelectionItems())
  }

  entityPath.value.forEach((entities) => {
    items.push(...makeEntityItems(entities))
  })

  return items
})
function makeEntityItems(entities: CoreEntityDto[]): BadgeListItem[] {
  const getEntityTitle = (entity: CoreEntityDto): string => {
    const titleSingular =
      entities.length > 0 ? t(getTitleKey(entities[0].type, false, realm ?? '')) : ''
    return entity.type === 'LEVEL'
      ? `${titleSingular} ${entity.properties?.level}`
      : entity.displayName
  }
  if (entities.length === 1) {
    return entities.map((x) => ({
      text: getEntityTitle(x)
    }))
  } else if (entities.length > 1) {
    const titlePlural =
      entities.length > 0 ? t(getTitleKey(entities[0].type, true, realm ?? '')) : ''
    const children: BadgeListItem[] = entities.map((x) => ({
      text: getEntityTitle(x)
    }))
    return [
      {
        text: `${entities.length} ${titlePlural.toLowerCase()}`,
        children
      }
    ]
  }
  return []
}

// function makeAggregateItems(selection: string[]): BadgeListItem[] {
//   if (selection.length > 0 && selection.length < 3) {
//     return selection.map((x) => ({
//       text: t(x),
//       color: '#d5d7f6'
//     }))
//   } else if (selection.length > 0) {
//     const children: BadgeListItem[] = selection.map((x) => ({
//       text: t(x)
//     }))
//     return [
//       {
//         text: `${selection.length} ${t('dashboard__text__measurement_tags').toLowerCase()}`,
//         color: '#d5d7f6',
//         children
//       }
//     ]
//   }
//   return []
// }

function makeTimeSelectionItems() {
  if (!range.value) return []
  const baseText = formatRange(range.value, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  })[locale.value]
  const finalText = businessTime.value ? `${baseText} (${businessTime.value})` : baseText

  return [
    {
      text: finalText as string,
      color: '#d5d7f6'
    }
  ]
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BadgeList, { items: badges.value }, null, 8, ["items"]))
}
}

})